import React from 'react';

const Triangle = (props) => (
  <svg width="6" height="12" viewBox="0 0 6 12" fill="#3E3E40" {...props}>
    <path d="M0 12L6 6L-5.24537e-07 0L0 12Z" />
  </svg>
);

export default Triangle;
